export const ALICUOTAS_IVA = [0, 10.5, 21, 27];

export function money(n) {
  const v = parseFloat(n);
  if (!Number.isFinite(v)) return 0;
  return Math.round(v * 100) / 100;
}

export function splitIva({ importe, alicuota, tipo }) {
  const amount = money(importe);
  const rate = Number(alicuota) || 0;
  const t = String(tipo || 'C').toUpperCase();

  if (t === 'C' || !rate) {
    return { neto: amount, iva: 0, total: amount, alicuota: 0 };
  }

  if (t === 'B') {
    const neto = money(amount / (1 + rate / 100));
    const iva = money(amount - neto);
    return { neto, iva, total: amount, alicuota: rate };
  }

  const iva = money(amount * rate / 100);
  return { neto: amount, iva, total: money(amount + iva), alicuota: rate };
}
